// extracted by mini-css-extract-plugin
export default {"container":"AccessTemplate_container__YY9QO","cardCreateTemplate":"AccessTemplate_cardCreateTemplate__ng3-J"};